import Button from '@/components/shared/Button';
import HomeIcon from '@/svg/home-icon.svg?url';
import CatalogIcon from '@/svg/catalog-icon.svg?url';
import SellIcon from '@/svg/sell-icon.svg?url';
import Link from '@/components/shared/Link';
import { useSetSelectedServiceValueFormState } from '@/atoms/form/selected-service-value-form-state';
import { useSetFeedbackPopupDataNameState } from '@/components/general/FeedbackPopup/use-feedback-popup-data-name-atom';
import { FEEDBACK_POPUP_NAME } from '@/components/general/FeedbackPopup/FeedbackPopup';
import { useSetOpenedPopupsState } from '@/atoms/opened-popups';
import { YD_NEW_ID } from '@/metrics/ym';
import { FAVORITES_POPUP_NAME } from '@/components/shared/FavoritesPopup/FavoritesPopup';
import FavouritesWhiteIcon from '@/svg/favourites-white.svg?url';
import CurrencyDropdown from '@/components/shared/CurrencyDropdown';
import { useNavProductDataState } from '@/atoms/product-nav-state';
import { toCurrency } from '@/utils/to-currency';
import { useRoubleToDollarCourseState } from '@/atoms/rouble-to-dollar-course';
import { useSetSelectedItemsState } from '@/atoms/form/selected-items-state';
import CompareSVG from '@/svg/compare-empty-black.svg?url';
import NewSvg from '@/svg/new.svg?url';
import PhoneSVG from '@/svg/phone.svg?url';
import ConciergeSVG from '@/svg/concierge-icon.svg?url';
import ViewedSVG from '@/svg/viewed-black.svg?url';
import SortSVG from '@/svg/sort.svg?url';
import { SORT_POPUP_NAME } from '@/components/layout/CatalogFilters/SortPopup';
import FilterSVG from '@/svg/filter.svg?url';
import { FILTERS_POPUP_NAME } from '@/components/layout/CatalogFilters/FiltersPopup';
import { useEuroToDollarCourseState } from '@/atoms/euro-to-dollar-course';
import { PHONE_BUTTON_POPUP_NAME } from '@/components/general/PhoneButton/PhoneButton';
import classNames from 'classnames';
import { forwardRef } from 'react';

const NavFiltersInner = forwardRef<HTMLDivElement>((props, ref) => {
    const setServiceValueFormState = useSetSelectedServiceValueFormState();
    const setFeedbackPopupDataName = useSetFeedbackPopupDataNameState();
    const { openPopup } = useSetOpenedPopupsState();
    const [navData] = useNavProductDataState();
    const [course] = useRoubleToDollarCourseState();
    const [euroCourse] = useEuroToDollarCourseState();

    const hasPrice = !!navData.price && Number(navData.price) !== 0;
    const isAvailable = !!navData.available && Number(navData.available) !== 0;

    const prices = hasPrice
        ? [
              toCurrency(navData.price, 'USD'),
              toCurrency(navData.price * course, 'RUB'),
              toCurrency(navData.price * euroCourse, 'EUR'),
          ]
        : [];
    const setSelectedItems = useSetSelectedItemsState();

    return (
        <div className="filter-inner" ref={ref}>
            <div className="filter-inner__left">
                <Button variant="primary" className="filter-inner__btn-left" tag={Link} href="/" size="sm">
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img src={HomeIcon} className="img-fluid" alt="" decoding="async" />
                    Главная
                </Button>
                <Button variant="primary" className="filter-inner__btn-left" tag={Link} href="/new-products" size="sm">
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img src={NewSvg} className="img-fluid" alt="" decoding="async" />
                    Новинки
                </Button>
                <Button variant="primary" className="filter-inner__btn-left" size="sm" tag={Link} href={'/catalog'}>
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img src={CatalogIcon} className="img-fluid" alt="" decoding="async" />
                    Каталог
                </Button>
                <Button
                    variant="primary"
                    className="filter-inner__btn-left"
                    size="sm"
                    onClick={() => {
                        setServiceValueFormState('продать');
                        setFeedbackPopupDataName('sell');
                        openPopup(FEEDBACK_POPUP_NAME);
                        window.ym?.(YD_NEW_ID, 'reachGoal', 'click_on_request');
                    }}
                >
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img src={SellIcon} className="img-fluid" alt="" decoding="async" />
                    Продать
                </Button>
                <Button
                    variant="primary"
                    className="filter-inner__btn-left"
                    size="sm"
                    onClick={() => {
                        setServiceValueFormState('консьерж');
                        setFeedbackPopupDataName('concierge');
                        openPopup(FEEDBACK_POPUP_NAME);
                        window.ym?.(YD_NEW_ID, 'reachGoal', 'click_on_request');
                    }}
                >
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img src={ConciergeSVG} className="img-fluid" alt="" decoding="async" />
                    Консьерж
                </Button>
                <Button
                    variant="primary"
                    className="filter-inner__btn-left"
                    size="sm"
                    onClick={() => {
                        openPopup(FAVORITES_POPUP_NAME);
                    }}
                >
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img src={FavouritesWhiteIcon} className="img-fluid" alt="" decoding="async" />
                    Избранное
                </Button>
            </div>
            <div
                className={classNames('filter-inner__right', {
                    'filter-inner__right--no-price': !hasPrice,
                })}
            >
                {isAvailable && hasPrice && (
                    <>
                        <CurrencyDropdown prices={prices} classname="filter-inner__dropdown" />
                        <Button
                            className="filter-inner__buy"
                            variant="primary"
                            onClick={() => {
                                setServiceValueFormState('Купить');
                                setSelectedItems([navData.title]);
                                setFeedbackPopupDataName('empty');
                                openPopup(FEEDBACK_POPUP_NAME);
                                window.ym?.(YD_NEW_ID, 'reachGoal', 'click_on_the_buy_button');
                            }}
                        >
                            Купить
                        </Button>
                    </>
                )}

                {!isAvailable && hasPrice && (
                    <div className="filter-inner__order">
                        <Button
                            variant="primary"
                            className="filter-inner__order-btn"
                            onClick={() => {
                                setServiceValueFormState('Под заказ');
                                setSelectedItems([navData.title]);
                                setFeedbackPopupDataName('order');
                                openPopup(FEEDBACK_POPUP_NAME);
                                window.ym?.(YD_NEW_ID, 'reachGoal', 'click_on_the_buy_button');
                            }}
                        >
                            Под заказ
                        </Button>

                        <Button
                            variant="primary"
                            className="filter-inner__buy"
                            onClick={() => {
                                setServiceValueFormState('Купить');
                                setSelectedItems([navData.title]);
                                setFeedbackPopupDataName('empty');
                                openPopup(FEEDBACK_POPUP_NAME);
                                window.ym?.(YD_NEW_ID, 'reachGoal', 'click_on_the_buy_button');
                            }}
                        >
                            Купить
                        </Button>
                    </div>
                )}
                <Button
                    tag={Link}
                    href="/compare"
                    variant="primary"
                    className="filter-inner__right-btn filter-inner__right-btn--compare"
                    size="sm"
                    icon={<img src={CompareSVG} className="img-fluid" alt="" decoding="async" />}
                    aria-label="перейти к сравнению"
                ></Button>
                <Button
                    tag={Link}
                    href="/viewed"
                    variant="primary"
                    className="filter-inner__right-btn filter-inner__right-btn--viewed"
                    aria-label="перейти к просматриваемым"
                    icon={<img src={ViewedSVG} className="img-fluid" alt="" decoding="async" />}
                ></Button>
                <Button
                    variant="primary"
                    className="filter-inner__sort"
                    onClick={() => openPopup(SORT_POPUP_NAME)}
                    size="sm"
                    icon={<img src={SortSVG} className="img-fluid" alt="" decoding="async" />}
                >
                    Сортировка
                </Button>
                <Button
                    variant="primary"
                    className="filter-inner__filter"
                    onClick={() => openPopup(FILTERS_POPUP_NAME)}
                    size="sm"
                    icon={<img src={FilterSVG} className="img-fluid" alt="" decoding="async" />}
                >
                    Фильтр
                </Button>
                <Button
                    variant="primary"
                    className="filter-inner__right-btn filter-inner__right-btn--feedback"
                    size="sm"
                    icon={<img src={PhoneSVG} className="img-fluid" alt="" width={17} height={16} decoding="async" />}
                    aria-label="Форма обратной связи"
                    onClick={() => {
                        openPopup(PHONE_BUTTON_POPUP_NAME);
                        window.ym?.(YD_NEW_ID, 'reachGoal', 'click_on_the_phone');
                    }}
                ></Button>
            </div>
        </div>
    );
});

NavFiltersInner.displayName = 'NavFiltersInner';

export default NavFiltersInner;
